import React, { memo, useState } from "react";
import Logo from "../Logo/Logo";
import Menu from "../Menu/Menu";
import { Link } from "gatsby";
import { useRootQuery } from "~/context/RootQuery/RootQuery";
import { cloneDeep } from "lodash";
import cx from "~/utils/cx";
import { Button, Icon } from "@caesars-ui/core";

const ignoredMenuSlugs = ["download/"];

const Nav = ({ theme }) => {
  const [isOpen, setIsOpen] = useState(false);
  const {menuData} = cloneDeep(useRootQuery());
  const filteredMenuData = cloneDeep(menuData).allMdx.edges.filter(
    (e) => !ignoredMenuSlugs.includes(e.node.slug)
  );

  return (
    <>
      <div className="lg:hidden fixed top-4 left-4 z-50">
        {isOpen ? (
          <Button
            type="tertiary"
            onClick={() => setIsOpen(false)}
            aria-label="Close menu"
            leftIcon={<Icon name="ui_x" size="md" />}
          />
        ) : (
          <Button
            type="tertiary"
            onClick={() => setIsOpen(true)}
            aria-label="Open menu"
            leftIcon={<Icon name="ui_menu" size="md" />}
          />
        )}
      </div>
      <nav className={cx(
        {
          "translate-x-0 shadow-lg": isOpen,
          "-translate-x-full": !isOpen,
        },
        "flex flex-col w-[320px] min-h-screen px-[30px] py-10 bg-bg-layer-one fixed lg:sticky lg:top-0 lg:translate-x-0 lg:shadow-none transition-transform duration-300 z-40 overflow-y-auto"
      )}>
        <Link to="/" className="mt-12 lg:mt-0">
          <Logo theme={theme} />
        </Link>
        <Menu menuData={filteredMenuData} />
        <div className="text-fg-primary-strong">
          <Link to="/help-feedback">Help &amp; Feedback</Link>
        </div>
      </nav>
      {isOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-30"
          onClick={() => setIsOpen(false)}
        />
      )}
    </>
  );
};

export default memo(Nav);
